import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';

export const PrivacyPolicy: React.FC = () => {
  return (
    <div id="privacy" className="overflow-y-auto scrollbar-custom-y" style={{ height: "calc(100% - 80px)" }}>
            <Container>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: 600, margin: 0 }}>Политика конфиденциальности</h2>
      </div>

      <p style={{ color: '#666', fontSize: '0.875rem', marginBottom: '16px' }}>
        Дата последнего обновления: 22 декабря 2025 г.
      </p>

        <p>
          Настоящая Политика конфиденциальности регулирует порядок сбора, использования и защиты персональных данных
          пользователей приложения <strong>«O!-Chat»</strong> (далее — «Приложение»).
        </p>

        <h2 style={{ fontSize: '1.125rem', fontWeight: 600, marginTop: '24px', marginBottom: '12px' }}>1. Общие положения</h2>
        <p>
          Приложение предназначено для личного общения и обмена сообщениями между пользователями. Использование
          Приложения возможно только после прохождения авторизации.
        </p>
        <p>
          Мы уважаем ваше право на конфиденциальность и обязуемся защищать ваши персональные данные в соответствии с
          действующим законодательством Российской Федерации.
        </p>

        <h2 style={{ fontSize: '1.125rem', fontWeight: 600, marginTop: '24px', marginBottom: '12px' }}>
          2. Какие данные мы собираем
        </h2>
        <p>При регистрации и использовании Приложения мы можем собирать следующую информацию:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '8px' }}>
          <li>Номер телефона;</li>
          <li>Уникальный идентификатор устройства (device ID);</li>
          <li>IP-адрес;</li>
          <li>Журналы использования (дата и время входа, активность в чатах);</li>
          <li>Содержимое сообщений (только для доставки и отображения в чатах между пользователями);</li>
          <li>
            Фотографии, аудио и другие медиафайлы, отправленные вами в чатах (если такая функция реализована).
          </li>
        </ul>

        <h2 style={{ fontSize: '1.125rem', fontWeight: 600, marginTop: '24px', marginBottom: '12px' }}>
          3. Цели обработки данных
        </h2>
        <p>Собранные данные используются исключительно для:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '8px' }}>
          <li>Обеспечения работы Приложения (авторизация, доставка сообщений);</li>
          <li>Отправки уведомлений о новых сообщениях;</li>
          <li>Поддержания сеанса связи между пользователями;</li>
          <li>Обеспечения безопасности и предотвращения мошенничества;</li>
          <li>Улучшения функциональности и пользовательского опыта.</li>
        </ul>
        <p>
          Мы <strong>не передаём ваши данные третьим лицам</strong>, кроме случаев, прямо предусмотренных
          законодательством РФ.
        </p>

        <h2 style={{ fontSize: '1.125rem', fontWeight: 600, marginTop: '24px', marginBottom: '12px' }}>
          4. Хранение и защита данных
        </h2>
        <p>
          Все данные хранятся на защищённых серверах. Мы применяем современные технические и организационные меры для
          защиты информации от несанкционированного доступа, уничтожения или изменения.
        </p>

        <h2 style={{ fontSize: '1.125rem', fontWeight: 600, marginTop: '24px', marginBottom: '12px' }}>5. Ваши права</h2>
        <p>Вы имеете право:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '8px' }}>
          <li>Получить информацию о том, какие данные о вас хранятся;</li>
          <li>Запросить исправление или удаление своих данных;</li>
          <li>Отозвать согласие на обработку персональных данных (в этом случае ваш аккаунт будет удалён).</li>
        </ul>
        <p>
          Для реализации этих прав свяжитесь с нами по адресу электронной почты:  
         <Link to="mailto:info@factfactor.ru"> info@factfactor.ru</Link>.
        </p>

        <h2 style={{ fontSize: '1.125rem', fontWeight: 600, marginTop: '24px', marginBottom: '12px' }}>
          6. Изменения в Политике
        </h2>
        <p>
          Мы оставляем за собой право вносить изменения в настоящую Политику. Новая редакция будет опубликована в
          Приложении с указанием даты обновления.
        </p>
        <p>
          Продолжая использовать Приложение после внесения изменений, вы автоматически соглашаетесь с обновлённой
          версией.
        </p>
            </Container>
      </div>
  );
};
